"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var DocumentPageInput_1 = __importDefault(require("./DocumentPageInput"));
var useStyles = styles_1.makeStyles({
    root: {
        display: 'block',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        userSelect: 'none',
        '& *': {
            // Font size needs to be proportional to page width. Why? Because we
            // resize images to fit within the available viewport, so the larger the
            // image, the more we shrink it. And since our SVG layout is the same size
            // as our image, that gets shrunk too. So all the fonts get smaller. So we
            // have to make them bigger to compensate. Hope that's clear :)
            fontSize: function (pageWidth) { return pageWidth / 110 + "px"; },
            fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
        },
    },
});
var DocumentPageInputs = function (_a) {
    var actor = _a.actor, isAutosignActive = _a.isAutosignActive, onChangeInput = _a.onChangeInput, onFocusInput = _a.onFocusInput, onReachInputMaxLength = _a.onReachInputMaxLength, inputs = _a.inputs, pageHeight = _a.pageHeight, pageWidth = _a.pageWidth;
    var classes = useStyles(pageWidth);
    return (react_1.default.createElement("svg", { className: classes.root, viewBox: "0 0 " + pageWidth + " " + pageHeight, onDoubleClick: function (e) {
            // Only register double-clicks on background
            var isOnThisNode = e.target.isSameNode(e.currentTarget);
            if (!isOnThisNode)
                e.stopPropagation();
        } }, inputs.map(function (input) { return (react_1.default.createElement("g", { key: input.id, id: "input-" + input.id },
        react_1.default.createElement("foreignObject", { height: input.height, width: input.width, x: input.left, y: input.top },
            react_1.default.createElement(DocumentPageInput_1.default, { actor: actor, input: input, isAutosignActive: isAutosignActive, onChange: function (value) { return onChangeInput(input.id, value); }, onFocus: function () { return onFocusInput(input.id); }, onReachMaxLength: function () { return onReachInputMaxLength(input.id); } })))); })));
};
exports.default = DocumentPageInputs;
//# sourceMappingURL=DocumentPageInputs.js.map